import { useState } from 'react'
import { useCallback } from 'react'

import { Button } from 'core-components/library/button'
import {
  TLink,
  TLinkButtonColors,
  TLinkView,
} from 'core-components/library/richTextEditor/interface/Tlink'
import {
  Controller,
  isEmpty,
  ValidateInput,
  ValidationStatus,
} from 'core-components/library/validation'

import { ButtonLinkSettings } from './ButtonLinkSettings'
import { CommonLinkSettingsContent } from './CommonLinkSettingsContent'

import styles from './LinkSettingsDialogContent.module.scss'

export interface ILinkDialogContentProps {
  link: TLink
  type: TLinkView
  onCancel: () => void
  onSave: (link: TLink) => void
  src?: string
}

export const LinkSettingsDialogContent = (props: ILinkDialogContentProps) => {
  const [canSave, setCanSave] = useState(false)

  const [link, setLink] = useState<TLink>({
    text: props.link.text || '',
    url: props.link.url || '',
    backgroundColor: props.link.backgroundColor,
    openInNewTab: props.link.openInNewTab,
    fontSize: props.link.fontSize,
    iconPosition: props.link.iconPosition,
    icon: props.link.icon,
  })

  const setLinkFields = useCallback(
    (field: string, value: string | boolean | TLinkButtonColors) => {
      setLink((prev) => ({ ...prev, [field]: value }))
    },
    []
  )

  return (
    <Controller
      onValidationStatusChange={(result) => {
        setCanSave(result.status === ValidationStatus.Valid)
      }}
    >
      <div className={styles.root}>
        {props.type === 'image' ? (
          <img src={props.src} className={styles.imagePreview} />
        ) : (
          <ValidateInput
            label={'Text'}
            value={link.text}
            onChange={(value) => setLinkFields('text', value)}
            margin={'md'}
            checkFn={isEmpty}
          />
        )}
        <CommonLinkSettingsContent
          url={link.url}
          openInNewTab={link.openInNewTab}
          onChange={(field, value) => setLinkFields(field, value)}
          required={true}
        />
        {props.type === 'button' ? (
          <ButtonLinkSettings link={link} setLinkFields={setLinkFields} />
        ) : null}
        <div className={styles.footer}>
          <Button
            onClick={() => {
              props.onSave(link)
            }}
            disabled={!canSave}
          >
            Apply
          </Button>
          <Button className={styles.cancelButton} onClick={props.onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </Controller>
  )
}
